import { ThemeProvider as MuiThemeProvider } from '@material-ui/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { UserManagementClient } from '@webdev/user-management';
import React from 'react';
import { ConfigProvider } from '../config/ConfigContext';
import { PublicConfig } from '../config/types';
import { FeedbackProvider } from '../feedback';
import {
  PaymentProviderContext,
  SsoSessionContext,
  UserProfile,
  UserProfileContext,
} from '../Session';
import { ShopTokenContext } from '../Session/ShopTokenContext';
import { theme } from '../theme';
import { Module, ModuleProps } from './modules';
import { PaymentProvider } from './services/AuthServiceTypes';
import { JWTToken, SelfServiceProvider } from './services/selfService';
import { SsoGatewayProvider, SsoSession } from './services/ssogateway';
import { UserManagementClientContext } from './user-management/UserManagementClientContext';

export interface AppProps extends ModuleProps {
  queryClient: QueryClient;
  config?: PublicConfig;
  shopToken?: JWTToken;
  paymentProvider?: PaymentProvider;
  userProfile?: UserProfile;
  ssoSession?: SsoSession;
  userManagementClient: UserManagementClient;
}

const App: React.FC<AppProps> = ({
  queryClient,
  config,
  shopToken,
  paymentProvider,
  userProfile,
  ssoSession,
  userManagementClient,
  ...props
}) => (
  <QueryClientProvider client={queryClient}>
    <ConfigProvider initialConfig={config}>
      <FeedbackProvider>
        <UserManagementClientContext userManagementClient={userManagementClient}>
          <SsoGatewayProvider>
            <SsoSessionContext ssoSession={ssoSession}>
              <ShopTokenContext shopToken={shopToken}>
                <PaymentProviderContext paymentProvider={paymentProvider}>
                  <UserProfileContext userProfile={userProfile}>
                    <SelfServiceProvider>
                      <MuiThemeProvider theme={theme}>
                        <Module {...props} />
                      </MuiThemeProvider>
                    </SelfServiceProvider>
                  </UserProfileContext>
                </PaymentProviderContext>
              </ShopTokenContext>
            </SsoSessionContext>
          </SsoGatewayProvider>
        </UserManagementClientContext>
      </FeedbackProvider>
    </ConfigProvider>
  </QueryClientProvider>
);
export default App;
